export default {
  apiKey: process.env.REACT_APP_REMOTE_APIKEY,
  baseURL: process.env.REACT_APP_BASEURL,
  imageApiKey: process.env.REACT_APP_REMOTE_IMAGE_APIKEY,
  imageServer: process.env.REACT_APP_IMAGE_SERVER,
  maxRetries: process.env.REACT_APP_MAXRETRIES,
  paymentURL: process.env.REACT_APP_PAYMENTURL,
};
